import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  SchedulerScreenVisitQuery,
} from "~/graphql/__generated__/graphql";
import PermissionOrWarn from "~/components/common/PermissionOrWarn";
import SchedulerScreen from "~/components/scheduler/SchedulerScreen";
import { Permission } from "~/hooks/permissions";

export default function SchedulerVisitScreen() {
  const { visitId } = useParams();

  const { data, loading } =
    useQuery<SchedulerScreenVisitQuery>(VISIT_QUERY, {
      variables: {
        visitId: parseInt(visitId || ""),
      },
      fetchPolicy: "network-only",
    });
  const visit = data?.visitSingle;

  return <PermissionOrWarn permission={Permission.manageAnyVisit}>
    <SchedulerScreen visit={visit} loading={loading} key={`${visit?.patient?.id}-${visit?.patient?.updatedAt}`} />
  </PermissionOrWarn>
}

const VISIT_QUERY = gql`
  query SchedulerScreenVisit($visitId: Int)
  @permission(requires: manageAnyVisit)
  {
    visitSingle(where: { id: { eq: $visitId } }) {
      id
      startTime
      endTime
      arrivalWindowStartTime
      arrivalWindowEndTime
      serviceInstructions
      visitTypeId
      createdAt
      patient {
        id
        firstName
        lastName
        dateOfBirth
        sex
        patientNotes
        serviceInstructions
        addressStreet
        addressCity
        addressState
        addressZip
        addressTimezone
        phone
        updatedAt

        episodes {
          id
          active
          serviceLineId
          organizationalUnitId
          updatedAt
          precautions {
            id
            precautionId
          }
        }

        patientIdentifiers {
          identifier
          identifier_type
        }
      }
      visitResources {
        id
        provider {
          id
          firstName
          lastName
        }
      }
      visitServices {
        id
        service {
          id
          name
        }
      }
      episode {
        id
        serviceLineId
        organizationalUnitId
      }
    }
  }
`;
